// extracted by mini-css-extract-plugin
export var chevronIcon = "_c0-2";
export var teamName = "_c0-1";
export var teamSwitcherButton = "_c0-0";